import { render, staticRenderFns } from "./AppPopup.vue?vue&type=template&id=28e27e86&scoped=true"
import script from "./AppPopup.vue?vue&type=script&lang=js"
export * from "./AppPopup.vue?vue&type=script&lang=js"
import style0 from "./AppPopup.vue?vue&type=style&index=0&id=28e27e86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e27e86",
  null
  
)

export default component.exports